"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_hot_loader_1 = require("react-hot-loader");
const icon_1 = require("./icon");
const DirectoryEntry = styled_components_1.default.tr `
  border-top: 1px solid #eaecef;

  &:first-child {
    border-top: none;
  }
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f6f8fa;
    transition: background-color 0.1s ease-out;
  }

  & td {
    padding-top: 8px;
    padding-bottom: 8px;
    vertical-align: middle;
    width: auto;
    padding-left: 8px;
  }

  & td:last-child {
    text-align: right;
    padding-right: 10px;
  }
`;
DirectoryEntry.displayName = "DirectoryEntry";
class Entry extends React.PureComponent {
    render() {
        return (React.createElement(DirectoryEntry, null, React.Children.map(this.props.children, child => {
            if (child && react_hot_loader_1.areComponentsEqual(child.type, icon_1.Icon)) {
                return React.createElement("td", { style: { width: "25px" } }, child);
            }
            return React.createElement("td", null, child);
        })));
    }
}
exports.Entry = Entry;
Entry.defaultProps = {
    children: null
};
exports.default = Entry;
